import { paperLightTheme } from './paperLightTheme';
/**
 * Active app theme: React Native Paper MD3 + AbbisWay tokens on `colors`.
 *
 * **Dark mode later:** add `paperDarkTheme` and resolve from `Appearance` / context;
 * pass the chosen theme to `PaperProvider` and export it here.
 */
export const theme = paperLightTheme;
